import { render } from "./MainForm.vue?vue&type=template&id=2118d679"
const script = {}

import "./MainForm.vue?vue&type=style&index=0&id=2118d679&lang=scss"

import exportComponent from "/builds/snedson/snedson-auth-backend/snedson-auth-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__